var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSelectIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 15,
    viewBox: "0 0 25 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7146 14.27C13.3674 14.6171 12.8965 14.812 12.4056 14.812C11.9147 14.812 11.4439 14.6171 11.0967 14.27L0.623433 3.79671C0.446607 3.62592 0.305564 3.42163 0.208535 3.19576C0.111506 2.96988 0.0604336 2.72694 0.0582974 2.48112C0.0561613 2.23529 0.103005 1.9915 0.196094 1.76398C0.289183 1.53645 0.426654 1.32974 0.600485 1.1559C0.774316 0.982073 0.981026 0.844602 1.20855 0.751513C1.43608 0.658424 1.67987 0.611581 1.9257 0.613717C2.17152 0.615854 2.41446 0.666926 2.64034 0.763955C2.86621 0.860984 3.0705 1.00203 3.24129 1.17885L12.4056 10.3432L21.57 1.17885C21.9191 0.841608 22.3868 0.654999 22.8722 0.659217C23.3577 0.663435 23.822 0.858143 24.1653 1.2014C24.5085 1.54467 24.7032 2.00902 24.7075 2.49444C24.7117 2.97987 24.5251 3.44753 24.1878 3.79671L13.7146 14.27Z",
    fill: "#A0A8B1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectIcon);
export default __webpack_public_path__ + "static/media/select-icon.60fe26f8b9a466effd2738d90dd0d1c8.svg";
export { ForwardRef as ReactComponent };